import { FloatingFocusManager, FloatingPortal, useMergeRefs } from '@floating-ui/react';
import * as React from 'react';
import VoxelPanel, { VoxelPanelProps } from '../Surfaces/VoxelPanel';
import { zIndexVoxel } from '../../../logic/zIndexVoxel';
import { usePopoverContext } from './PopoverLogic';
import { VoxelPopoverArrow } from './VoxelPopoverArrow';

/*
  Richard comment:
  99% of this is just from floating ui example
  some of it is overkill, but it's easier to just copy and use in our app
*/

export const VoxelPopoverContent = React.forwardRef<
  HTMLDivElement,
  VoxelPanelProps & { arrowClasses?: string; sourceWidth?: boolean; initialFocus?: number }
>(({ style, arrowClasses, sourceWidth = false, initialFocus, ...props }, propRef) => {
  const { context: floatingContext, ...context } = usePopoverContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!floatingContext.open) return null;

  return (
    <FloatingPortal>
      <FloatingFocusManager
        context={floatingContext}
        modal={context.modal}
        initialFocus={initialFocus}
      >
        <div
          style={{
            ...context.floatingStyles,
            ...style,
            outline: 'none',
            width: sourceWidth
              ? context.refs.domReference?.current?.clientWidth
              : context.floatingStyles.width,
          }}
          ref={ref}
          className={zIndexVoxel.popover}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
        >
          <VoxelPanel
            shadowClass={props.shadowClass ?? context.enableArrow ? 'drop-shadow-md' : 'shadow-md'}
            {...context.getFloatingProps({
              ...props,
              className: props.className,
            })}
          >
            {context.enableArrow && (
              <VoxelPopoverArrow className={'fill-white ' + arrowClasses} width={20} />
            )}
            {props.children}
          </VoxelPanel>
        </div>
      </FloatingFocusManager>
    </FloatingPortal>
  );
});
